import ScmPageRenderer from '@/components/scm/ScmPageRenderer';
import { suppliersPageDef } from '@/components/scm/scm-page-defs';

export default function ScmSuppliersPage() {
  return <ScmPageRenderer pageDef={suppliersPageDef} />;
}
